angular.module('jv.Common.AjaxSelect', [])

/*
//
Creates a generic select2 container.
<span 
    jv-ajax-select-url="url to query"   // 
    jv-ajax-select
    jv-ajax-select-object
    jv-ajax-select-id="id" 
    jv-ajax-select-no-search // if no search box needs to be displayed. 
    jv-ajax-select-text="text" 
    jv-ajax-select-query-param-name="q"
    jv-ajax-select-result-count-name="count"
    jv-ajax-select-allow-clear="true/false" //Used to show or hide remove icon.
    ng-model="questionnairNameForm.questionnaireObject" 
    jv-ajax-select-can-clear="true/false" // Used to specify if the user can clear the select2 and go have no option selected
    jv-ajax-select-placeholder="Select Questionnaire" >
    'Select and option ' default text when user hits 'x' on select2 
</span>
**/

.directive('jvAjaxSelect',['$window', '$timeout', function($window, $timeout){
    function link(scope, element, attribute, ngController) {
        var pageSize = attribute.jvPageSize || 10;
        var encodeOption = function(value){
            return (angular.isDefined(value) && value != null) ? $('<div/>').text(value).html() : value;
        };
        // Set the configurations
        var url = attribute.jvAjaxSelectUrl;
        var responseKey = attribute.jvAjaxSelectResponseKey || 'resultList';
        var objectName = attribute.jvAjaxSelectObjectName;
        var dontShowSearch = angular.isDefined(attribute.jvAjaxSelectNoSearch) || false;
        var queryParamName = attribute.jvAjaxSelectQueryParamName;
        var resultCountName = attribute.jvAjaxSelectResultCountName || 'resultCount';
        var isMultiple = (attribute.jvAjaxSelectMultiple === 'multiple');
        var config = $.extend(true, {}, {
            placeholder: attribute.jvAjaxSelectPlaceholder|| i18n['SELECT_AN_OPTION'] ||'Select an option',
            minimumInputLength: 0,
            multiple: isMultiple,
            allowClear: true,
            dropdownCssClass: attribute.jvAjaxSelectDropdownClass || '',
            minimumResultsForSearch: dontShowSearch ? -1 : 0,
            ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
                url: url,
                quietMillis: 500,
                dataType: 'json',
                data: function (term, page) {
                    var postData = {
                        maxResults : pageSize,
                        page: page-1,    //VA: select2 page is 1 based, our backend is 0 based.
                        offset: page-1,   //In memory pagination needs [offset and count] to be passed(HIRE-8630)
                        count: pageSize
                    };
                    if(attribute.jvAjaxSelectQueryParamName){
                       postData[attribute.jvAjaxSelectQueryParamName] = term;
                       
                    }else{
                        postData.keywords = term;
                    }
                    return postData;
                },
                results: function(data, page){
                    if(angular.isDefined(data.resultCount) && angular.isDefined(data.pageCount)){
                        pageSize=data.pageCount;
                    }
                    // select2 page is 1 based, our backend is 0 based.
                    var more = (attribute.jvAjaxSelectNoPagination) ? false : ((page * pageSize) < (data[resultCountName] || data.employeesCount) || (pageSize - 2 < (data && data.resultList && data.resultList.length)));
                    if(angular.isDefined(data) && angular.isDefined(data[responseKey]) && data[responseKey].length>0 ){
                        
                        if(attribute.jvAjaxSelectResponseType ==='string'){
                            angular.forEach(data[responseKey],function(dataObj,key){
                                var dataItem = {
                                    name: dataObj,
                                    index: key
                                };
                                data[responseKey][key] = dataItem;
                            });
                        }
                        if(attribute.jvAjaxSelectResponseType ==='object'){
                            angular.forEach(data[responseKey],function(dataObj,key){
                                var dataItem = dataObj[objectName];
                                data[responseKey][key] = dataItem;
                            });
                        }
                        return {"results": data[responseKey], more: more};
                    }else{
                        return {"results":[]};
                    }
                }
            },
            formatSelection: function(item){
                return encodeOption(item[attribute.jvAjaxSelectedText] ? item[attribute.jvAjaxSelectedText] : item[attribute.jvAjaxSelectText]);
                //return item.title;
            },
            formatResult: function(item){
                return encodeOption(item[attribute.jvAjaxSelectText]);
                //return item.title;
            },
            id: function(item){
                return item[attribute.jvAjaxSelectId];
                //return item.SId;
            },
            initSelection: function(element, callback){
                if(angular.isDefined(ngController.$modelValue) && ngController.$modelValue && ngController.$modelValue !==null){
                    callback(ngController.$modelValue);
                }else{
                    var data = {};
                    data[attribute.jvAjaxSelectId] = null;
                    data[attribute.jvAjaxSelectText]=null;
                    callback(data);
                }
                
            }
        }, ($window._jvPluginDefaults && $window._jvPluginDefaults.select2), scope.$eval(attribute.jvAjaxSelect));

        $(element).select2(config).on('change', function(selectedObject){
            var select2Data = $(element).select2('data') || selectedObject.val;
            var canClearOptions = false;
            if(attribute.jvAjaxSelectCanClear === 'true'){
                canClearOptions = true;
            }
            //You either have data which is not null or you canClearOptions only then update the model
            if(select2Data ||  canClearOptions){
                $timeout(function() {
                    var valObject;
                    if (attribute.jvAjaxSelectObject !== undefined && attribute.jvAjaxSelectObject !== false) {
                        valObject = $(element).select2('data');
                    } else {
                        valObject = selectedObject.val;
                    }
                    ngController.$setViewValue(valObject);
                });
            }

        });

        scope.$watch(attribute.ngModel, function(newVal, oldVal){
            var canClearOptions = false;
            if(attribute.jvAjaxSelectCanClear === 'true'){
                canClearOptions = true;
            }
            if(attribute.jvAjaxSelectAllowClear === 'false'){
                element.parent().find('abbr').css('display','none');
            }
            /*if user can clearOptions and the newVal is null then set the option value as select an option which is the default
             * fullName is initialized specifically for the hiring manager filter as it has name under the fullName attribute
             */
            if(  ( (!newVal && canClearOptions) || (newVal === null && canClearOptions) )){
                if(attribute && attribute.jvAjaxSelectId && attribute.jvAjaxSelectId === 'key'){
                    //if Select2, key and value is defined, then don't set default option
                    $(element).select2('data', '');
                } else{
                    $(element).select2('data', {
                        'name': attribute.jvAjaxSelectPlaceholder || i18n['SELECT_AN_OPTION'],
                        'title': attribute.jvAjaxSelectPlaceholder || i18n['SELECT_AN_OPTION'],
                        'fullName': attribute.jvAjaxSelectPlaceholder || i18n['SELECT_AN_OPTION']
                    });
                }
            }
            //This is to pre-poulate the value
            if(attribute.jvAjaxSelectId && angular.isDefined(attribute.jvAjaxSelectPopulate)){
                if((typeof newVal === 'object' && newVal !== null && $.isEmptyObject(newVal)) || canClearOptions && (angular.isUndefined(newVal) || newVal === ''|| newVal === i18n['SELECT_AN_OPTION'])){
                    //setting list as empty when value is set as empty
                    $(element).select2('data', '');
                } else if(newVal && newVal[attribute.jvAjaxSelectId]){
                    $(element).select2('data', newVal);
                } else if(newVal && newVal.length > 0 && isMultiple) {
                    $(element).select2('data', newVal);
                } else if(typeof newVal === 'string' && attribute.jvAjaxSelectId !== 'currencyCode') {
                    $(element).select2('data', {
                        'key': newVal,
                        'value': newVal,
                        'category': newVal,
                        [attribute.jvAjaxSelectId]: newVal
                    });
                } else if(newVal != i18n['SELECT_AN_OPTION'] && attribute.jvAjaxSelectId !== 'currencyCode'){
                    $(element).select2('data', {
                        'name': newVal || i18n['SELECT_AN_OPTION'],
                        'title': newVal || i18n['SELECT_AN_OPTION'],
                        'fullName': newVal || i18n['SELECT_AN_OPTION'],
                        [attribute.jvAjaxSelectId]: newVal || i18n['SELECT_AN_OPTION']
                    });
                }
            }
        });

    }

    return{
        require: 'ngModel',
        link: link
    };

}]);
